import axios from 'axios';

export const checkProductNameUniqueness = async ({ token, name, productId } = {}) => {
    try {
        const params = new URLSearchParams({ productName: name });
        if (productId) {
            params.append('productId', productId);
        }

        const response = await axios({
            method: 'get',
            url: `${process.env.REACT_APP_API_URL}/products/check/uniqueness?${params.toString()}`,
            headers: {
                Authorization: token,
            },
        });

        if (response instanceof Error) {
            return { error: response };
        }

        return response;
    } catch (error) {
        return { error };
    }
};

export default checkProductNameUniqueness;
